import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

import { IconConfiguration } from '@celum/common-components/icon';

import { Systembar } from '../../model/systembar/systembar';
import { AvatarComponent } from '../avatar/avatar-component';
import { HelpComponent } from '../help-component/help-component';
import { ServiceTabItemComponent } from '../service/service-tab-item-component';
import { ServiceTabsComponent } from '../service-tabs/service-tabs-component';

@Component({
  selector: 'celum-systembar',
  templateUrl: './systembar-component.html',
  styleUrl: './systembar-component.less',
  imports: [AvatarComponent, HelpComponent, ServiceTabsComponent, ServiceTabItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'celum-systembar' }
})
export class CelumSystembarComponent {
  public readonly systembar = input<Systembar>();

  protected readonly icons = {
    configuration: new IconConfiguration('celum').withIconDimensions(25, 32),
    organisationDetails: new IconConfiguration('settings-outlined-colored').withIconSize(34)
  };
}
